/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTextIcon16Solid = forwardRef('FileTypeTextIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.597 1.586A2 2 0 0 0 9.182 1H4.5A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h7a2.5 2.5 0 0 0 2.5-2.5V5.817a2 2 0 0 0-.586-1.414l-2.817-2.817ZM5 6a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V7H6a1 1 0 0 1-1-1Z" })));
});
